export function pascalToCamel(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(pascalToCamel);
    } else if (obj !== null && typeof obj === 'object') {
        return Object.keys(obj).reduce((acc: any, key) => {
            const camelKey = key.charAt(0).toLowerCase() + key.slice(1);
            acc[camelKey] = pascalToCamel(obj[key]);
            return acc;
        }, {});
    }
    return obj;
}